module.exports = __webpack_public_path__ + "static/img/card1.12984fa3.png";